import moment from 'moment';
import 'moment-timezone';
import store from '../../../stores/redux';
import UserStore from '../../../stores/UserStore';
import typeOf from '../../../helpers/typeOf';

const getLocale = () => {
    return store.getState().user.locale || 'en';
};

const getTimeZone = (timeZone = null) => {
    return UserStore.getValidTimeZone(timeZone);
};

const convert = (seconds) => {  // millisecond translation
    return seconds * 1000;
};

const parseDate = (date, timeZone = 'UTC', isMoment = false) => {
    const resolvedTimeZone = getTimeZone(timeZone);
    if (typeOf.isNumeric(date)) {
        date = convert(date);
    }
    let momentDate = moment.tz(date, resolvedTimeZone).locale(getLocale());

    if (resolvedTimeZone !== 'UTC') {
        momentDate.tz('UTC');
    }

    return isMoment ? momentDate : momentDate.toDate();
};

export {
    getLocale,
    getTimeZone,
    convert,
    parseDate
};
